import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { SchedulingSettingPeriod } from '../../shared/models/scheduling-setting-period';
import { IMyDateModel } from 'mydatepicker';

@Injectable()
export class ScheduleService {
    private scheduleDate: string;
    private schedulePeriod: SchedulingSettingPeriod;
    private selectedScheduleDateSource: Subject<string> = new Subject();
    private selectedSchedulePeriodSource: Subject<SchedulingSettingPeriod> = new Subject();

    public selectedScheduleDate$ = this.selectedScheduleDateSource.asObservable();
    public selectedSchedulePeriod$ = this.selectedSchedulePeriodSource.asObservable();

    public setScheduleDateAsIMyDateModel(dateModel: IMyDateModel) {
        const date = moment(dateModel.jsdate);

        this.selectedScheduleDateSource.next(date.format('YYYY-MM-DD'));
    }
    public setScheduleDate(date: string) {
        this.selectedScheduleDateSource.next(date);
    }
    public setSchedulingSettingPeriod(period: SchedulingSettingPeriod) {
        this.selectedSchedulePeriodSource.next(period);
    }
    public getScheduleDate(): string {
        return this.scheduleDate;
    }
    public getSchedulePeriod(): SchedulingSettingPeriod {
        return this.schedulePeriod;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/payment/services/schedule.service.ts